import { Get } from "../http/httpVerbs";

export const apiGetAprendaStats = async (comunidade) => {
    try {
        let url = `${process.env.REACT_APP_API_URL}/aprenda/stats/${comunidade}`;

        const response = await Get(url);

        return response;
    } catch (error) {
        console.error("API apiGetAprendaStats ERROR:", error);
        throw error;
    }
};
